import { type IntegrationDefinition, type IntegrationEndpointInfo } from './types'

export const getIntegrationEndpoints = (
  integration: IntegrationDefinition | null | undefined,
): IntegrationEndpointInfo[] => integration?.endpoints ?? []

export const validateHostUrl = (
  host: string,
  integration: IntegrationDefinition | null | undefined,
): { isValid: boolean; errorMessage: string | null } => {
  const hostValidation = integration?.hostValidation
  if (!host || !hostValidation) return { isValid: true, errorMessage: null }

  const cleanHost = host.replace(/^https?:\/\//, '').replace(/\/+$/, '')
  if (!hostValidation.pattern.test(cleanHost)) {
    return {
      isValid: false,
      errorMessage: `Host must match the expected format (e.g., ${hostValidation.example})`,
    }
  }
  return { isValid: true, errorMessage: null }
}

export const buildTestCredentials = (
  integration: IntegrationDefinition | null | undefined,
  formData: Record<string, string>,
): Record<string, string> => {
  if (integration?.apiConfig.buildTestCredentials) {
    return integration.apiConfig.buildTestCredentials(formData)
  }
  return { host: formData.host, api_key: formData.apiKey }
}
